export const DELIVERY_COUNT_PLACEHOLDER = "{{deliveryCount}}";
